// PUT && POST Id, Body, Params
// GET ID and Params
import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/itineraries`, params);
    return data;
  },

  getMinResponse: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/itineraries/browse-itineraries`, params);
    return data;
  },

  create: async (body, query) => {
    const params = { params: query };
    const { data } = await axios.post(`/itineraries`, body, params);
    return data;
  },

  getById: async (id, params) => {
    const { data } = await axios.get(`/itineraries/${id}`, { params });
    return data;
  },

  update: async (id, body) => {
    const res = await axios.put(`/itineraries/${id}`, {
      itinerary: body
    });

    return res;
  },

  delete: async id => {
    const { data } = await axios.delete(`/itineraries/${id}`);
    return data;
  },

  updateStatus: async (id, query) => {
    const params = { params: query };
    const res = await axios.put(
      `/itineraries/${id}/update-status`,
      null,
      params
    );

    return res;
  },

  addPOI: async (id, body) => {
    const { data } = await axios.put(`/itineraries/${id}/add-poi`, body);
    return data;
  },

  removePOI: async (id, body) => {
    const { data } = await axios.put(`/itineraries/${id}/remove-poi`, body);
    return data;
  },

  updatePOI: async (id, body, query) => {
    const params = { params: query };
    const { data } = await axios.put(
      `/itineraries/${id}/update-poi`,
      body,
      params
    );
    return data;
  },

  bookmark: async (id, body) => {
    const { data } = await axios.put(`/itineraries/${id}/bookmark`, body);
    return data;
  },

  unbookmark: async id => {
    const res = await axios.delete(`/itineraries/${id}/bookmark`);
    return res;
  },

  projectValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/itineraries/projects/values`, params);
    return data;
  }
};
